<template>
  <div>
    <a-card style="margin-bottom: 10px">
      <search-view
        :renderItem="BATCH_SEARCH_SCHEMA"
        :isExpandShowOrNot="false"
        :initialValues="initSearchForm"
        @fetchSearch="handleSearch"
      ></search-view>
    </a-card>
    <a-card>
      <div class="text-right">
        <!-- 新增批量申请modal -->
        <batch-upload-modal
          ref="batchUploadModal"
          btnText="新增批量申请"
          icon="plus"
          modal-title="新增批量申请"
          @ok="handleBatchModalOk"
          @download="_downloadTemp"
        />
      </div>
      <table-view
        bordered
        :data="tableData"
        :columns="columns"
        :pagination="pageData"
        :loading="tableLoading"
        :scroll="SCROLL"
        @handlePagination="handlePagination"
      >
        <span slot="fileNameTitle">
          <a-tooltip>
            <template slot="title">
              下载文件可查看校验结果
            </template>
            <a-icon type="info-circle" />
            上传文件
          </a-tooltip>
        </span>

        <template v-slot:status="{ tableRow }">
          <a-tag
            :color="BATCH_STATUS_OBJ[tableRow.status].color"
            style="width: 80px; text-align: center;"
          >
            {{ BATCH_STATUS_OBJ[tableRow.status].label }}
          </a-tag>
        </template>
        <template v-slot:file="{ tableRow }">
          <a herf="javascript:;" @click="handleDownload(tableRow.id)">
            {{ tableRow.fileName }}
          </a>
        </template>
        <template v-slot:action="{ tableRow }">
          <a-button
            type="link"
            size="small"
            v-if="tableRow.status == 1"
            @click="toShowApproveModal(tableRow)"
          >
            提交申请
          </a-button>
          <a-button
            type="link"
            size="small"
            v-else-if="
              tableRow.status == 3 ||
                tableRow.status == 4 ||
                tableRow.status == 5
            "
            @click="toBatchDetailPage(tableRow)"
          >
            查看
          </a-button>
        </template>
      </table-view>
    </a-card>
    <!-- 提交审批modal -->
    <a-modal
      title="提交申请"
      :visible="showApproveModal"
      :mask-closable="false"
      @ok="handleApproveModalOk"
      @cancel="handleApproveModalCancel"
      :confirm-loading="approveModalOkLoading"
      width="80%"
    >
      <a-form
        :form="approveForm"
        :label-col="{ span: 4 }"
        :wrapper-col="{ span: 18 }"
      >
        <a-form-item
          label="添加审批人"
          required
          :help="personErr"
          :validate-status="personErr ? 'error' : 'success'"
        >
          <a-select
            style="width: 300px"
            v-model="checkApprovalPersons"
            showSearch
            allowClear
            option-filter-prop="children"
            required
          >
            <a-select-option v-for="item in managerList" :key="item.username">
              {{ item.name }} - {{ item.username }}
            </a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item
          label="申请原因及备注"
          required
          :help="remarkErr"
          :validate-status="remarkErr ? 'error' : 'success'"
        >
          <quill-editor :token="token" ref="quillEditor"></quill-editor>
        </a-form-item>
        <a-form-item :wrapper-col="{ offset: 4 }">
          <affix ref="affix" :maxSize="30"></affix>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { SearchView, TableView } from 'lxfintech-fe'
import BatchUploadModal from 'components/BatchUploadModal.vue'
import QuillEditor from './../credit-approval/components/QuillEditor.vue'
import cloneDeep from 'lodash/cloneDeep'
import Affix from './components/Affix.vue'
import { BATCH_STATUS_OBJ } from './const'
import { BATCH_SEARCH_SCHEMA } from './schema'
import {
  uploadRelationBatch,
  getRelationBatchList,
  downloadBatchFile,
  downloadTemp,
  getApprovePersons,
  apply,
} from './api'
import { ERR_OK } from 'config/index'
import { formatParamDate } from 'utils/util'
export default {
  data() {
    const initSearchForm = {
      id: '',
      endTime: '',
      startTime: '',
      status: '',
    }
    const searchForm = cloneDeep(initSearchForm)
    //这里存放数据
    return {
      BATCH_SEARCH_SCHEMA,
      initSearchForm,
      BATCH_STATUS_OBJ,
      searchForm,
      tableData: [],
      managerList: [],
      columns: [
        {
          title: '序号',
          customRender: (text, record, index) => {
            return (
              (this.pageData.current - 1) * this.pageData.pageSize + index + 1
            )
          },
          width: 80,
          fixed: 'left',
        },
        {
          title: '批量申请编号',
          dataIndex: 'id',
          width: 150,
        },
        {
          title: '申请数量',
          dataIndex: 'total',
          width: 100,
        },
        {
          title: '系统验证通过数量',
          dataIndex: 'success',
          width: 150,
        },
        {
          title: '添加时间',
          dataIndex: 'createTime',
          width: 120,
        },
        {
          title: '提交审批时间',
          dataIndex: 'submitTime',
          width: 120,
        },
        {
          title: '操作人',
          dataIndex: 'operator',
          width: 120,
        },
        {
          title: '状态',
          scopedSlots: { customRender: 'status' },
          width: 120,
        },
        {
          dataIndex: 'fileName',
          slots: { title: 'fileNameTitle' },
          scopedSlots: { customRender: 'file' },
        },
        {
          title: '操作',
          scopedSlots: { customRender: 'action' },
          width: 100,
          fixed: 'right',
        },
      ],
      checkApprovalPersons: '',
      pageData: {
        pageSize: 10,
        current: 1,
        total: 0,
        showTotal: total => `共${total}条`,
      },
      tableLoading: false,
      SCROLL: { x: 1500 },
      showApproveModal: false,
      approvalId: '', // 正在提交审批的id
      approveForm: this.$form.createForm(this, { name: 'approveForm' }),
      personErr: '',
      remarkErr: '',
      isBatch: '',
      approveModalOkLoading: false,
    }
  },
  components: {
    SearchView,
    BatchUploadModal,
    TableView,
    QuillEditor,
    Affix,
  },
  computed: {
    ...mapGetters('user', ['token']),
  },
  //方法集合
  methods: {
    // 点击查看提交的页面
    toBatchDetailPage({ bpmId }) {
      this.$router.push({
        path: `/customer-credit/group-relationship-batch-detail/${bpmId}`,
        query: {
          status: 2,
        },
      })
    },
    // 点击弹框进行申请
    toShowApproveModal({ id, needApprove }) {
      this.showApproveModal = true
      this.approvalId = id
      this.isBatch = needApprove
      this._getApprovePersons(this.isBatch)
    },
    async _getApprovePersons(isBatch) {
      try {
        const { data } = await getApprovePersons(isBatch)
        this.managerList = data
      } catch (error) {
        this.loading = false
        console.error(error)
      }
    },
    // 点击查询按钮
    handleSearch(data) {
      data = formatParamDate(data, data.applyRangeDate)
      delete data.applyRangeDate
      this.searchForm = data
      this.pageData.current = 1 // 设置为第一页
      this._getRelationList(data)
    },
    // 分页
    handlePagination(pagination) {
      ;({
        current: this.pageData.current,
        pageSize: this.pageData.pageSize,
        total: this.pageData.total,
      } = pagination)
      this._getRelationList(this.searchForm)
    },
    handleApproveModalCancel() {
      this.showApproveModal = false
      this.approvalId = ''
      this.approveForm.resetFields()
    },
    // 批量上传模板
    _downloadTemp() {
      downloadTemp()
    },

    // 点击链接下载
    handleDownload(id) {
      downloadBatchFile(id)
    },
    /**
     * 申请
     */
    async handleApproveModalOk() {
      this.approveModalOkLoading = true
      try {
        const checkForm = await this.validateForm()
        if (!checkForm) {
          this.approveModalOkLoading = false
          return
        }
        const params = {
          id: this.approvalId,
          ...checkForm,
        }
        await apply(params)
        this.$message.success('申请成功')
        this.showApproveModal = false
        this.approveModalOkLoading = false
        this._getRelationList(this.searchForm)
      } catch (error) {
        this.approveModalOkLoading = false
      }
    },
    async validateForm() {
      const checkQuillEditor = this.$refs.quillEditor.getContent().trim()
      const attachmentIds = this.$refs.affix.getAttachmentIds()
      if (this.checkApprovalPersons === '') {
        this.$message.error('请选择审批人')
      }
      try {
        this.remarkErr = checkQuillEditor ? '' : '请输入申请原因及备注'
        const checkForm = await this.approveForm.validateFields()
        if (checkForm && checkQuillEditor) {
          return Promise.resolve({
            applyRemark: checkQuillEditor,
            approvePerson: this.checkApprovalPersons,
            attachmentIds,
          })
        } else {
          return Promise.resolve(false)
        }
      } catch (error) {
        console.error(error)
      }
    },
    async _getRelationList(searchForm) {
      if (this.tableLoading) {
        return
      }
      this.tableLoading = true
      const { current, pageSize } = this.pageData
      const formData = {
        ...searchForm,
        size: pageSize,
        current,
      }
      try {
        const {
          data: { total, records },
        } = await getRelationBatchList(formData)
        this.pageData.total = total
        this.tableData = records
        this.tableLoading = false
      } catch (error) {
        console.error(error)
      }
    },
    handleModalCancel() {
      this.$refs.batchUploadModal.handleCancel()
    },
    async handleBatchModalOk(fileList) {
      if (fileList && fileList.length) {
        try {
          const { code, message } = await uploadRelationBatch({
            file: fileList,
          })
          if (code === ERR_OK) {
            this.$notification.success({
              message: '提示',
              description: message || '成功',
            })
            this.handleModalCancel()
            this._getRelationList(this.searchForm)
          } else {
            this.$notification.error({
              message: '提示',
              description: message || '失败',
            })
          }
        } catch (error) {
          this.$refs.batchUploadModal.handleBeforeUploadCanceled()
          console.error(error)
        }
      } else {
        this.$message.warning('请上传文件！')
      }
    },
  },
  //生命周期 - 创建完成（访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（访问DOM元素）
  mounted() {
    this._getRelationList(this.initSearchForm)
  },
}
</script>
<style scoped>
/* @import url(); 引入css类 */
</style>
